<template>
  <div class="block-wrapper">
    <div>
      <el-tabs v-model="activeName" class="demo-tabs" @tab-click="() => {}">
        <el-tab-pane label="Description" name="description" class="row">
          <div class="col-6">
            <el-input
              v-model="blockContent.content.headline"
              placeholder="Headline"
            />
          </div>
          <div class="col-6">
            <el-input
              v-model="blockContent.content.subheadline"
              placeholder="Sub headline"
            />
          </div>
        </el-tab-pane>
        <el-tab-pane label="Top Artists" name="artistsId">
          <div class="col" v-if="blockContent?.content?.artists?.length > 0">
            <draggable
              :list="blockContent.content.artists"
              item-key="id"
              class="artists-draggable-list"
              ghost-class="ghost-artist-row"
              handle=".drag-handle"
            >
              <template #item="{ index: i }">
                <div class="relative-parent artist-draggable-row">
                  <span
                    class="drag-handle"
                    title="Drag to reorder"
                    aria-label="Drag to reorder"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 320 512"
                      width="14"
                      height="14"
                      fill="currentColor"
                    >
                      <path
                        d="M40 352l48-48c9.4-9.4 24.6-9.4 33.9 0l48 48c9.4 9.4 9.4 24.6 0 33.9l-48 48c-9.4 9.4-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9zm192-224l-48 48c-9.4 9.4-24.6 9.4-33.9 0l-48-48c-9.4-9.4-9.4-24.6 0-33.9l48-48c9.4-9.4 24.6-9.4 33.9 0l48 48c9.4 9.4 9.4 24.6 0 33.9zM40 160l48 48c9.4 9.4 24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9l-48-48c-9.4-9.4-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9zm192 192l-48-48c-9.4-9.4-24.6-9.4-33.9 0l-48 48c-9.4 9.4-9.4 24.6 0 33.9l48 48c9.4 9.4 24.6 9.4 33.9 0l48-48c9.4-9.4 9.4-24.6 0-33.9z"
                      />
                    </svg>
                  </span>
                  <div
                    class="delete-row"
                    style="z-index: 1"
                    @click="
                      () => {
                        blockContent.content.artists.splice(i, 1);
                      }
                    "
                  >
                    <svg
                      class="svg-inline--fa fa-trash-alt fa-w-14"
                      data-v-b4ae8fbc=""
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="trash-alt"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                      data-fa-i2svg=""
                    >
                      <path
                        fill="currentColor"
                        d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                      ></path>
                    </svg>
                  </div>
                  <el-select
                    v-model="blockContent.content.artists[i]"
                    filterable
                    remote
                    reserve-keyword
                    placeholder="Please enter a keyword"
                    :remote-method="remoteMethod"
                    value-key="id"
                    :loading="loading"
                  >
                    <el-option
                      v-for="item in artistsListCopy"
                      :label="item.name"
                      :key="item.id"
                      :value="item"
                    />
                  </el-select>
                </div>
              </template>
            </draggable>
          </div>
          <el-button @click="addNewRow" class="mt-2" size="small" type="primary"
            >Add new artist</el-button
          >
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
  <el-button
    @click="deleteBlock(blockData.id)"
    class="mt-2"
    size="small"
    type="danger"
    >Delete this block</el-button
  >
</template>
<script>
import draggable from "vuedraggable";

export default {
  name: "DiscoverArtistArchive",
  components: {
    draggable,
  },
  props: {
    blockData: Object,
  },
  data() {
    return {
      listOfArtist: [],
      artistsListCopy: [],
      artistsListRaw: [],
      loading: false,
      blockContent: {
        content: {
          headline: "",
          subheadline: "",
          artists: [],
        },
      },
      activeName: "description",
    };
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === "COLLECT_BLOCK_CONTENT") {
        this.$store.dispatch("updateBlockContent", {
          blockData: this.blockData,
          blockContent: this.blockContent,
        });
      }
    });
    if (this.blockData.created_at) {
      this.artistsListCopy = this.blockData.content.artists;
      this.blockContent.content = this.blockData.content;
      this.normalizeArtistRowsForDrag();
    }
  },
  beforeUnmount() {
    this.unsubscribe();
  },
  methods: {
    normalizeArtistRowsForDrag() {
      const rows = this.blockContent.content.artists;
      if (!rows?.length) return;
      const base = Date.now();
      this.blockContent.content.artists = rows.map((row, idx) => {
        if (typeof row === "string") {
          return {
            id: -(base + idx),
            name: "",
            _placeholderLabel: row,
          };
        }
        return row;
      });
    },
    addNewRow() {
      const n = this.blockContent.content.artists.length;
      this.blockContent.content.artists.push({
        id: -(Date.now() + n),
        name: "",
      });
    },
    deleteBlock(id) {
      this.$store.dispatch("removeBlockFromList", id);
    },
    remoteMethod: function (query) {
      if (query) {
        this.loading = true;
        this.artistsListCopy = [];
        this.$api
          .get(
            `${
              process.env.VUE_APP_SHARED_API
            }api/artists?search=${query.toLowerCase()}`
          )
          .then((res) => {
            if (res.data.data) {
              res.data.data.map((art) => {
                this.artistsListRaw.push(art);
                this.artistsListCopy.push(art);
              });
              this.loading = false;
            } else {
              this.loading = false;
            }
          });
      } else {
        this.artistsListCopy = [];
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.block-wrapper {
  border: #adb2ad solid 1px;
  padding: 16px 20px;
}
.input-bottom {
  padding-left: 8px;
  margin-top: 8px;
}
.delete-row {
  position: absolute;
  top: 5px;
  right: 5px;
  height: 20px;
  width: 20px;
  cursor: pointer;
  display: flex;
  align-content: center;
  justify-content: center;
  background-color: red;
  border-radius: 50%;
  align-items: center;
}
.delete-row > svg {
  color: white;
  fill: white;
}
.relative-parent {
  position: relative;
}
.artists-draggable-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.artist-draggable-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 36px 4px 4px;
  position: relative;
}
.artist-draggable-row .delete-row {
  top: 50%;
  right: 4px;
  transform: translateY(-50%);
}
.drag-handle {
  flex-shrink: 0;
  cursor: grab;
  color: #909399;
  display: flex;
  align-items: center;
  padding: 4px 6px;
  user-select: none;
}
.drag-handle:active {
  cursor: grabbing;
}
.artist-draggable-row .el-select {
  flex: 1;
}
.ghost-artist-row {
  opacity: 0.55;
}
</style>

